import { render, staticRenderFns } from "./Regioncode.vue?vue&type=template&id=501150bc&scoped=true&"
import script from "./Regioncode.vue?vue&type=script&lang=js&"
export * from "./Regioncode.vue?vue&type=script&lang=js&"
import style0 from "./Regioncode.vue?vue&type=style&index=0&id=501150bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501150bc",
  null
  
)

export default component.exports